import { buildUserAvatarPublicUrl } from './build-user-avatar-public-url';
import { normalizeCacheBustTimestamp } from './normalize-cache-bust-timestamp';

/** ユーザーアバター表示用。`iconUrl` は公開 URL（未設定は null）。 */
export function toUserAvatarSource(
  supabaseUrl: string,
  user: {
    id: string;
    name: string;
    avatarPath?: string | null;
    avatarUpdatedAt?: string | Date | null;
  },
): { id: string; name: string; iconUrl: string | null } {
  return {
    id: user.id,
    name: user.name,
    iconUrl: buildUserAvatarPublicUrl(
      supabaseUrl,
      user.avatarPath,
      normalizeCacheBustTimestamp(user.avatarUpdatedAt),
    ),
  };
}
